module.exports = __webpack_public_path__ + "static/media/safari-pwa-2.ba5aacdf.svg";